<div class="modal-header">
    <h4 class="modal-title">Transfers list filter</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row" style="width: 100%;">
        <div class="col-md-12">
            <div class="main-card card">
                <div class="card-body">
                    <h2 class="card-title">Text filter (applies on fields id, name and audience descriptor as id + name )</h2>            
                    <mat-form-field style="width: 100%;">
                        <mat-label>Text</mat-label>
                        <input type="text" matInput [formControl]="textSearchFormControl" placeholder="Ex. 'search term'" (keyup.enter)="onAcceptClick()" />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onResetFilterClick()">Reset filter</button>        
    <button type="button" class="btn btn-secondary" (click)="onAcceptClick()">Accept</button>        
    <button type="button" class="btn btn-secondary" (click)="dismiss()">Close</button>
</div>